import { BaseCell, type BaseCellProps } from "@similarweb/pro-logic-components";

import { MultiCountry } from "app/components/React/Table/cells/MultiCountryCell";

import { DATA_AUTOMATION_COUNTRY_GROUP_VALUE } from "../const";

type Props = { countryCodes: readonly number[]; recordIndex: number; extraCountLink?: string } & BaseCellProps;

const CountryGroupCell = ({
    countryCodes,
    children,
    recordIndex,
    dataAutomation,
    extraCountLink,
    ...baseCellProps
}: Props) => {
    return (
        <BaseCell
            {...baseCellProps}
            dataAutomation={dataAutomation ?? DATA_AUTOMATION_COUNTRY_GROUP_VALUE}
        >
            <MultiCountry
                id={recordIndex}
                countries={countryCodes as number[]}
                extraCountLink={extraCountLink}
            />
        </BaseCell>
    );
};

export default CountryGroupCell;
